import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Process from './components/Process';
import TechStrip from './components/TechStrip';
import Careers from './components/Careers';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
  <div className="App">
      <Navbar />
      <main id="main-content">
        <Hero />
        <Services />
        <About />
        <Process />
        <TechStrip />
        <Careers />
        <Contact />
        <PrivacyPolicy />
      </main>
      <Footer />
    </div>
  );
}

export default App;
